<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <router-view></router-view>
  </transition>
</template>
<script>
import globalConfig from "./resource/utiles/globalConfig";

export default {
  beforeCreate() {
    globalConfig.setRouterQuery(this.$route.query);
    globalConfig.setRoute(this.$route);
    globalConfig.init();
  },
};
</script>
<style>
html {
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>

